export default "__VITE_ASSET__BrNT0u2y__"